import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { DiagnosticsPage } from "go-component/components/Diagnostics";
import { DiagnoseElementApi } from "go-component/services/types";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { selectUser } from "go-security/services/users/selectors";
import { apiOrganization } from "../../../../../../services/Api/Organization/apiOrganization";

export const OrganizationDiagnosticsPage = () => {
	const organization = useSelector(selectOrganization);
	const user = useSelector(selectUser);
	const { getDiagnosticsTypes, diagnose, getDiagnoseProgress, diagnoseFix } = apiOrganization;
	const { t } = useTranslation();

	const renderDiagnseElementLink = (diagnoseElement: DiagnoseElementApi, id: string, title: string) => {
		switch (diagnoseElement.resource_type) {
			case "PRODUCT":
				return (
					<Link to={`/${organization.id}/products/${id}/edit`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "CONTACT":
				return (
					<Link to={`/${organization.id}/contacts/${id}`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "PRODUCT_CATEGORY":
				return (
					<Link to={`/${organization.id}/products/categories/${id}/edit`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "PURCHASE_ORDER":
				return (
					<Link to={`/${organization.id}/documents/purchases/${id}`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "SALES_ORDER":
				return (
					<Link to={`/${organization.id}/documents/sales/${id}/edit`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "STOCK":
				return (
					<Link to={`/${organization.id}/settings/stocks/${id}/edit`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "STOCKTAKING":
				return (
					<Link to={`/${organization.id}/stocktakings/${id}`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "STOCKTAKING_DRAFT":
				return (
					<Link to={`/${organization.id}/stocktakings/${id}/drafts`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "STOCK_ADJUSTMENT":
				return (
					<Link to={`/${organization.id}/documents/stock_adjustments/${id}`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			case "TRANSFER_ORDER":
				return (
					<Link to={`/${organization.id}/documents/transfers/${id}`} target="_blank" rel="noreferrer">
						{title}
					</Link>
				);
			default:
				return (
					<>
						{diagnoseElement.resource_type}: {diagnoseElement.id}{" "}
						{diagnoseElement.link ? (
							<a href={diagnoseElement.link} target="_blank" rel="noreferrer">
								{t("common.action.goto", { ns: "lib" })}
							</a>
						) : (
							""
						)}
					</>
				);
		}
	};

	return (
		<DiagnosticsPage
			organization={organization}
			user={user}
			renderDiagnseElementLink={renderDiagnseElementLink}
			diagnoseElementTitleKeyFormat="enums.message_events.resource_type"
			getDiagnosticsTypes={getDiagnosticsTypes}
			diagnose={diagnose}
			getDiagnoseProgress={getDiagnoseProgress}
			diagnoseFix={diagnoseFix}
		/>
	);
};
